import { Injectable } from '@angular/core';
import { AGUUrlSyncedHostAdapter, type AGUAppSurfaceConfig } from 'agu_app_shell';

/** Body class that puts Explorer into immersive OEP mode (styles.scss immersive-surface mixin). */
export const OEP_IMMERSIVE_BODY_CLASS = 'oep-immersive';

/** Element selector the immersive predicate measures for this surface. */
export const OEP_SURFACE_SELECTOR = 'mj-oep-surface';

/**
 * The OEP surface is the FeedbackPlatform application's dashboard (metadata Application
 * `FeedbackPlatform`), so that app is never a "Back to MJ Explorer" target.
 */
export const OEP_SURFACE_CONFIG: AGUAppSurfaceConfig = {
    SurfaceSelector: OEP_SURFACE_SELECTOR,
    ImmersiveBodyClass: OEP_IMMERSIVE_BODY_CLASS,
    OwnApplicationNames: ['FeedbackPlatform'],
};

/**
 * The OEP surface's host adapter. A named subclass so DI has a stable, greppable token
 * (RA precedent, ExplorerRaHostAdapter). URL mirroring comes from AGUUrlSyncedHostAdapter:
 * the FeedbackPlatform tab is an app-default dashboard, the tab shape whose query params
 * ng-explorer-core 5.51 drops (see that class).
 */
@Injectable()
export class ExplorerOEPHostAdapter extends AGUUrlSyncedHostAdapter {}
